import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/LogIn',
      name: 'LogIn',
      component: () => import('../views/LogInView.vue')
    },
    {
      path: '/Register',
      name: 'Register',
      component: () => import('../views/RegisterView.vue')
    },
    {
      path: '/RegHelper',
      name: 'RegHelper',
      component: () => import('../views/RegHelperView.vue')
    },
    {
      path: '/RegDistrict',
      name: 'RegDistrict',
      component: () => import('../views/RegDistrictView.vue')
    },
    {
      path: '/Activation',
      name: 'Activation',
      component: () => import('../views/ActivationView.vue'),
      props: route => ({ token: route.query.token })
    },
    {
      path: '/Reset',
      name: 'Reset',
      component: () => import('../views/ResetView.vue'),
      props: route => ({ token: route.query.token })
    },
    {
      path: '/Account',
      name: 'Account',
      component: () => import('../views/AccountView.vue')
    },
    {
      path: '/Request',
      name: 'Request',
      component: () => import('../views/RequestView.vue')
    },
    {
      path: '/district',
      name: 'district',
      component: () => import('../views/DistrictView.vue')
    },
    {
      path: '/Impressum',
      name: 'imprint',
      component: () => import('../views/ImprintView.vue')
    },
    {
      path: '/Datenschutz',
      name: 'privacy',
      component: () => import('../views/PrivacyView.vue')
    },
    {
      path: '/FAQ',
      name: 'faq',
      component: () => import('../views/FAQView.vue')
    },
    {
      path: '/Spenden',
      name: 'donate',
      component: () => import('../views/DonateView.vue')
    }
  ]
})

export default router
